module.exports = __webpack_public_path__ + "static/media/ck_logo_new.89238060.png";